module.exports = __webpack_public_path__ + "img/logo_rspb.0f92bdb2.jpg";